var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_744_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 6.04167C4.66602 8.34131 6.53304 10.2083 8.83268 10.2083C11.1323 10.2083 12.9993 8.34131 12.9993 6.04167C12.9993 3.74202 11.1323 1.875 8.83268 1.875C6.53304 1.875 4.66602 3.74202 4.66602 6.04167V6.04167",
    stroke: "#64748B",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 17.4899C15.9993 13.8105 13.0121 10.8232 9.33268 10.8232C5.65325 10.8232 2.66602 13.8105 2.66602 17.4899",
    stroke: "#64748B",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_1557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfIcon);
export default __webpack_public_path__ + "static/media/self-icon.2140b33d1e0c1a96f48821fe8a38e1fd.svg";
export { ForwardRef as ReactComponent };